export const useLanguages = () => {
  return {
    data: LANGUAGES,
    options: computed(() => Object.values(LANGUAGES)),
  };
};
